export const BASE_URL = 'https://api.rd-trading.net/api'
